import { render, staticRenderFns } from "./MaterialPicker.vue?vue&type=template&id=d713dde0"
import script from "./MaterialPicker.vue?vue&type=script&lang=js"
export * from "./MaterialPicker.vue?vue&type=script&lang=js"
import style0 from "./MaterialPicker.vue?vue&type=style&index=0&id=d713dde0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports